// BlogPage.js - Standalone Blog Post Page
import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import ContactFooter from '../components/ContactFooter';
import { BlogPost } from './Blog';
import styles from './BlogPage.module.css';

// Blog post data - moved from TechnologyPage for modularity
export const blogPosts = [
  {
    path: "linux_kernel",
    postPath: "/post/linux_kernel/Building_a_Custom_Linux_Kernel.md",
    title: "Building a Custom Linux Kernel",
    description: "A comprehensive guide to building a custom Linux kernel from source",
    category: "Linux Kernel",
    backgroundImage: "url(/post/linux_kernel/Linux%20kernel%20diagram%20high%20level.png)",
    featured: false
  },

  {
    path: "autoencoder_conv",
    postPath: "/post/autoencoder_conv/vae_gan_comprehensive_blog_post.md",
    title: "Autoencoder Convolutional",
    description: "Convolutional Variational Autoencoder with GAN",
    category: "Deep Learning",
    backgroundImage: "url(/post/autoencoder_conv/thumbnail.png)",
    featured: true
  },
  {
    path: "autoencoder_trans",
    postPath: "/post/autoencoder_trans/comprehensive_transformer_vae_blog_post.md",
    title: "Autoencoder Transformer",
    description: "Transformer Variational Autoencoder with GAN",
    category: "Deep Learning",
    backgroundImage: "url(/post/autoencoder_trans/thumbnail.png)",
    featured: true
  },
  {
    path: "deepseekv2-dissect",
    postPath: "/post/deepseekv2_dissect/deepseekv2_dissect.md",
    title: "DeepSeek V2 Dissect",
    description: "Deep dive into the DeepSeek V2 model architecture and its components",
    category: "Deep Learning",
    backgroundImage: "url(/post/deepseekv2_dissect/ds_thumbnail.png)",
    featured: true
  },
  {
    path: "transformer",
    postPath: "/post/Transformer.md",
    title: "Transformer Architecture",
    description: "Deep dive into the revolutionary attention mechanism that powers modern AI",
    category: "Deep Learning",
    backgroundImage: "url(/post/media/AttentionMatrix.jpg)",
    featured: true
  },
  {
    path: "moe",
    postPath: "/post/MoE.md",
    title: "Mixture of Experts",
    description: "Scaling neural networks efficiently with sparse expert routing",
    category: "Architecture",
    backgroundImage: "url(/post/media/MoE_Dalle.webp)",
    featured: false
  },
  {
    path: "gan",
    postPath: "/post/GAN.md",
    title: "Generative Adversarial Networks",
    description: "Understanding adversarial training and synthetic data generation",
    category: "Generative AI",
    backgroundImage: "url(/post/media/GANMnist.jpg)",
    featured: true
  },
  {
    path: "humanoid",
    postPath: "/post/Humanoid.md",
    title: "Humanoid Robotics",
    description: "Integration of AI and mechanical engineering in autonomous systems",
    category: "Robotics",
    backgroundImage: "url(/post/media/LinearActuator.jpg)",
    featured: false
  },
  {
    path: "dqn",
    postPath: "/post/DQN.md",
    title: "Deep Q-Networks",
    description: "Reinforcement learning for complex decision-making systems",
    category: "Reinforcement Learning",
    backgroundImage: "url(/post/media/DQN.jpg)",
    featured: false
  },
  {
    path: "image-diffusion",
    postPath: "/post/ImageDiffusion.md",
    title: "Image Diffusion Models",
    description: "State-of-the-art generative models for high-quality image synthesis",
    category: "Computer Vision",
    backgroundImage: "url(/post/media/diffusion.png)",
    featured: true
  },
  {
    path: "speech-synthesis",
    postPath: "/post/SpeechSynthesis.md",
    title: "Neural Speech Synthesis",
    description: "Advanced techniques for natural voice generation and audio processing",
    category: "Audio AI",
    backgroundImage: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    featured: false
  },
  {
    path: "cnn",
    postPath: "/post/CNN.md",
    title: "Convolutional Neural Networks",
    description: "Foundation architectures for computer vision and spatial data processing",
    category: "Computer Vision",
    backgroundImage: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    featured: false
  }
];

export default function BlogPage() {
  const location = useLocation();
  const postId = location.pathname.split('/').pop(); // Get the last segment of the URL
  const bannerImageUrl = "/images/BannerPage1.jpg";
  
  // Find the current post
  const currentPost = blogPosts.find(post => post.path === postId);
  
  if (!currentPost) {
    return (
      <div className={styles.pageContainer}>
        <Header 
          backgroundImageUrl={bannerImageUrl} 
          subtitle="Article Not Found" 
        />
        <div className={styles.notFound}>
          <h1>Article Not Found</h1>
          <p>The requested article could not be found.</p>
        </div>
        <ContactFooter 
          title="Research Collaboration"
          description="Interested in discussing these topics or collaborating on research? Let's explore the possibilities together."
          copyrightText="© 2025 Entrosystem. All rights reserved."
          backgroundImageUrl={bannerImageUrl}
        />
      </div>
    );
  }

  return (
    <div className={styles.pageContainer}>
      <Header 
        backgroundImageUrl={bannerImageUrl} 
        subtitle={`${currentPost.category} | ${currentPost.title}`} 
      />
      
      <main className={styles.blogContainer}>
        <BlogPost postPath={currentPost.postPath} />
      </main>

      <ContactFooter 
        title="Research Collaboration"
        description="Interested in discussing these topics or collaborating on research? Let's explore the possibilities together."
        copyrightText="© 2025 Entrosystem. All rights reserved."
        backgroundImageUrl={bannerImageUrl}
      />
    </div>
  );
}
